import { render } from "./internal-identified-enrolments-overview.vue?vue&type=template&id=f4d420fa&ts=true"
import script from "./internal-identified-enrolments-overview.ts?vue&type=script&lang=ts&external"
export * from "./internal-identified-enrolments-overview.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__